import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { ModalCard, LinkCard } from "./Cards";
import { ModalText } from "./Modals";
import { Table } from "../theme/text";
export default () => markdown `

# Cards

There are two types of cards: Modal cards open a \`Modal\`, Link cards open a new page.


## \`<ModalCard />\`

Modal cards are buttons that trigger the display of a pop-up modal, appended to the \`body\` of the document. Any child passed to the card will be displayed in the modal.

### Modal card with text as child
${(<ReactSpecimen>
    <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der Bevölkerungsbestand wird für die Parameterschätzungen verwendet, welche auf historischen Daten basieren." icon="Info">
      <ModalText>
        Als Bevölkerungsbestand wird in dieser Publikation die historische
        Bestandesgrösse der Bevölkerung bezeichnet. Der Bevölkerungsbestand wird
        für die Parameterschätzungen verwendet, welche auf historischen Daten
        basieren.
      </ModalText>
    </ModalCard>
  </ReactSpecimen>)}
### Modal card with a table as child
${(<ReactSpecimen>
    <ModalCard title="Aktualisierungsverlauf" text="Provisorische Daten; die Daten können ändern, wenn weitere Fälle
      nachgemeldet werden. Nachmeldungen nach statistischem Jahresabschluss
      werden dem Januar des Folgejahres zugeordnet." icon="Info">
      <Table headers={["Bereich", "Planung"]} rows={[
    ["Baustellenliste  A–Z", "Umsetzungstermin offen"],
    ["Archiv der Medienmitteilungen 2002–2007", "Keine Umsetzung"]
]}/>
    </ModalCard>
  </ReactSpecimen>)}


## \`<LinkCard />\`

Link cards are links. They must be passed a \`url\` props.
${(<ReactSpecimen>
    <LinkCard url="#/components/cards" title="Starke Zunahme des Wohnungsbestandes" meta="Donnerstag, 8. Februar 2018" text="Im Jahr 2017 wurden in der Stadt Zürich 2662 neue Wohnungen gebaut. Weniger Abbrüche als im Vorjahr führen zu einer höheren Nettozunahme der Wohnungen." icon="Externallink"/>
  </ReactSpecimen>)}


## Many Cards

${(<ReactSpecimen span={6} responsive>
    <div style={{
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    maxWidth: "100%"
}}>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
      <ModalCard title="Bevölkerungsbestand" text="Als Bevölkerungsbestand wird in dieser Publikation die historische Bestandesgrösse der Bevölkerung bezeichnet. Der…" icon="Info"/>
    </div>
  </ReactSpecimen>)}
`;



// WEBPACK FOOTER //
// ./src/components/Cards.docs.tsx